// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"b93c7282","47":"8497f780","66":"bff05dd9","81":"2733ddb9","148":"a9a7a29c","159":"a33c7897","263":"d5460485","333":"22322e2a","356":"b037f1a5","412":"281e65e0","567":"1949fae2","602":"aec4efa0","650":"8d0d82ed","694":"6805a630","776":"1d071086","787":"946de56b"}[chunkId] + ".chunk.js";
};